import React, { createContext, useState, useContext, useEffect } from "react";

// Créer un contexte pour la langue
const LangContext = createContext();

// Créer un provider qui permet de gérer la langue dans l'ensemble de l'application
export const LangProvider = ({ children }) => {
  const supportedLangs = ["en", "de", "fr", "it"];

  const languageCandidates = Array.isArray(navigator.languages)
    ? navigator.languages
    : [navigator.language || navigator.userLanguage || "en"];
  const preferredLanguage =
    languageCandidates
      .map((value) => value.split("-")[0].toLowerCase())
      .find((value) => supportedLangs.includes(value)) || "fr";

  // Vérifier si la langue du navigateur est supportée, sinon utiliser 'fr'
  const defaultLang = preferredLanguage;
  const storedLang = localStorage.getItem("lang");
  const initialLang = supportedLangs.includes(storedLang)
    ? storedLang
    : defaultLang;
  const [lang, setLang] = useState(initialLang);

  useEffect(() => {
    localStorage.setItem("lang", lang); // Sauvegarde la langue dans localStorage
  }, [lang]);

  const changeLanguage = (newLang) => {
    setLang(newLang);
  };

  return (
    <LangContext.Provider value={{ lang, changeLanguage }}>
      {children}
    </LangContext.Provider>
  );
};

// Hook pour récupérer la langue actuelle et la fonction pour la changer
export const useLang = () => useContext(LangContext);
